import React, { createContext, useContext } from 'react';
import frankStyles from 'components/frank/_style.module.scss';

// A hard_cardboard section is never printed (Frank::ManufacturingLineFinder::PRINTING_TYPES_BY_PART_TYPE has no
// row for it) -- its printing is priced on the cover section -- so users looking for printing among the Hard
// cardboard prices are pointed there, until they choose not to see it again.
//
// Drawn inside the shared cost column (QuoteBuilderNavColumn), right above the Material form where they look for
// printing; FrankQuoteBuilderPage provides what it needs. The legacy page provides nothing, so it draws nothing.
export const HardCardboardPrintingNoticeContext = createContext(null);

const HardCardboardPrintingNotice = ({ navSection }) => {
  const notice = useContext(HardCardboardPrintingNoticeContext);
  if (!notice || notice.hidden || navSection.part_type !== 'hard_cardboard') { return null; }

  return (
    <div className={frankStyles.hardCardboardPrintingNotice} data-frank-hard-cardboard-printing-notice>
      <i className={`fa fa-info-circle ${frankStyles.hardCardboardPrintingNoticeIcon}`} aria-hidden="true" />
      <span>{t('quote_builder.frank_hard_cardboard_printing_notice', { section: notice.coverLabel })}</span>
      <button type="button" className={frankStyles.hardCardboardPrintingNoticeAction} onClick={notice.goToCover}>
        {t('quote_builder.frank_hard_cardboard_printing_notice_go_to', { section: notice.coverLabel })}
      </button>
      <button type="button" className={frankStyles.hardCardboardPrintingNoticeAction} onClick={notice.dismiss}>
        {t('quote_builder.frank_hard_cardboard_printing_notice_dismiss')}
      </button>
    </div>
  );
};

export default HardCardboardPrintingNotice;
